import Vue from 'vue';

export default Vue.filter('stripHtml', value => {
  if (!value) {
    return '';
  }

  return value.replace(/<[^>]*>/g, ' ');
});
